import * as routeUtils from "~/contentful/route-utils";

// Don't have this here, this is handled by $slug
// Leaving it here as a reminder
// export const handle = routeUtils.handle("page");

export const headers = routeUtils.headers;

export const meta = routeUtils.meta;

export const loader = routeUtils.getContentfulPageLoader(undefined, "events");

export default routeUtils.ContentfulPageComponent;

export const ErrorBoundary = routeUtils.ContentfulErrorBoundary;

export const shouldRevalidate = routeUtils.shouldRevalidate;
